import React from "react";

class ProblemSolution extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "problems",
    };
  }

  toggleTab = tab => {
    this.setState({ activeTab: tab });
  };

  render() {
    const { activeTab } = this.state;

    const problems = [
      {
        icon: "🏗️",
        title: "Complex Project Management",
        description:
          "Multiple stakeholders and timelines create coordination challenges",
      },
      {
        icon: "💰",
        title: "Budget Overruns",
        description:
          "Unexpected costs and scope changes lead to financial strain",
      },
      {
        icon: "⏰",
        title: "Delayed Deliveries",
        description:
          "Supply chain issues and weather dependencies cause delays",
      },
      {
        icon: "🔧",
        title: "Quality Control Issues",
        description: "Maintaining standards across different trades and phases",
      },
    ];

    const solutions = [
      {
        icon: "📋",
        title: "Integrated Project Management",
        description:
          "End-to-end oversight from planning to completion with dedicated project managers",
      },
      {
        icon: "📊",
        title: "Transparent Cost Tracking",
        description:
          "Real-time budget monitoring and detailed cost breakdowns throughout the project",
      },
      {
        icon: "⚡",
        title: "Streamlined Workflows",
        description:
          "Optimized processes and reliable supplier networks for on-time delivery",
      },
      {
        icon: "🎯",
        title: "Quality Assurance Program",
        description:
          "Multi-stage inspections and certified professionals ensuring top-tier results",
      },
    ];

    const currentData = activeTab === "problems" ? problems : solutions;
    const currentTitle =
      activeTab === "problems" ? "What We're Solving For" : "How We're Solving";

    return (
      <div
        className="section-full bg-white content-inner "
        style={{ padding: "60px 0" }}
      >
        <div className="container ">
          {/* Section Header */}
          <div
            className="section-head text-center"
            style={{ marginBottom: "60px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "40px",
                flexWrap: "wrap",
                gap: "10px",
              }}
            >
              {/* Desktop Toggle Switch - Hidden on Mobile */}
              <div
                className="toggle-switch-container desktop-toggle"
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  background: "#f8f9fa",
                  borderRadius: "50px",
                  padding: "6px",
                  boxShadow: "inset 0 2px 6px rgba(0,0,0,0.1)",
                  border: "2px solid #e9ecef",
                  width: "auto",
                  minWidth: "380px",
                  maxWidth: "500px",
                }}
              >
                {/* Background Slider */}
                <div
                  style={{
                    position: "absolute",
                    top: "6px",
                    left: activeTab === "problems" ? "6px" : "50%",
                    width: "calc(50% - 6px)",
                    height: "calc(100% - 12px)",
                    background: `linear-gradient(45deg, ${
                      activeTab === "problems" ? "#f5be23" : "#3fa4ca"
                    }, ${activeTab === "problems" ? "#ff8c00" : "#2c7da0"})`,
                    borderRadius: "44px",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  }}
                />

                {/* Problems Button */}
                <button
                  onClick={() => this.toggleTab("problems")}
                  className="toggle-button"
                  style={{
                    position: "relative",
                    zIndex: 2,
                    padding: "14px 24px",
                    border: "none",
                    background: "transparent",
                    color: activeTab === "problems" ? "#fff" : "#666",
                    borderRadius: "44px",
                    cursor: "pointer",
                    fontSize: "15px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    flex: 1,
                    fontFamily: '"Poppins", sans-serif',
                    textShadow:
                      activeTab === "problems"
                        ? "0 1px 2px rgba(0,0,0,0.2)"
                        : "none",
                    whiteSpace: "nowrap",
                    overflow: "visible",
                    textAlign: "center",
                  }}
                >
                  What We're Solving For
                </button>

                {/* Solutions Button */}
                <button
                  onClick={() => this.toggleTab("solutions")}
                  className="toggle-button"
                  style={{
                    position: "relative",
                    zIndex: 2,
                    padding: "14px 24px",
                    border: "none",
                    background: "transparent",
                    color: activeTab === "solutions" ? "#fff" : "#666",
                    borderRadius: "44px",
                    cursor: "pointer",
                    fontSize: "15px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    flex: 1,
                    fontFamily: '"Poppins", sans-serif',
                    textShadow:
                      activeTab === "solutions"
                        ? "0 1px 2px rgba(0,0,0,0.2)"
                        : "none",
                    whiteSpace: "nowrap",
                    overflow: "visible",
                    textAlign: "center",
                  }}
                >
                  How We're Solving
                </button>
              </div>

              {/* Mobile Separate Buttons - Hidden on Desktop */}
              <div
                className="mobile-buttons"
                style={{
                  display: "none",
                  gap: "15px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <button
                  onClick={() => this.toggleTab("problems")}
                  style={{
                    padding: "12px 30px",
                    border: "2px solid #f5be23",
                    background:
                      activeTab === "problems" ? "#f5be23" : "transparent",
                    color: activeTab === "problems" ? "#000" : "#f5be23",
                    borderRadius: "30px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    minWidth: "160px",
                    fontFamily: '"Poppins", sans-serif',
                    boxShadow:
                      activeTab === "problems"
                        ? "0 4px 12px rgba(245, 190, 35, 0.3)"
                        : "none",
                  }}
                >
                  What We're Solving For
                </button>
                <button
                  onClick={() => this.toggleTab("solutions")}
                  style={{
                    padding: "12px 30px",
                    border: "2px solid #3fa4ca",
                    background:
                      activeTab === "solutions" ? "#3fa4ca" : "transparent",
                    color: activeTab === "solutions" ? "#fff" : "#3fa4ca",
                    borderRadius: "30px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    minWidth: "160px",
                    fontFamily: '"Poppins", sans-serif',
                    boxShadow:
                      activeTab === "solutions"
                        ? "0 4px 12px rgba(63, 164, 202, 0.3)"
                        : "none",
                  }}
                >
                  How We're Solving
                </button>
              </div>
            </div>

            <h2
              style={{
                fontSize: "clamp(28px, 5vw, 48px)",
                fontWeight: "700",
                color: activeTab === "problems" ? "#f5be23" : "#3fa4ca",
                margin: "0",
                fontFamily: '"Poppins", sans-serif',
                transition: "color 0.3s ease",
              }}
            >
              {currentTitle}
            </h2>

            <div
              style={{
                width: "100px",
                height: "4px",
                background: `linear-gradient(45deg, ${
                  activeTab === "problems" ? "#f5be23" : "#3fa4ca"
                }, ${activeTab === "problems" ? "#ff8c00" : "#2c7da0"})`,
                margin: "20px auto",
                borderRadius: "2px",
                transition: "background 0.3s ease",
              }}
            />
          </div>

          {/* Content Grid */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "30px",
              maxWidth: "1200px",
              margin: "0 auto",
            }}
          >
            {currentData.map((item, index) => (
              <div
                key={index}
                style={{
                  background: "#fff",
                  borderRadius: "20px",
                  padding: "40px 30px",
                  textAlign: "center",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  border: `3px solid ${
                    activeTab === "problems"
                      ? "rgba(245, 190, 35, 0.2)"
                      : "rgba(63, 164, 202, 0.2)"
                  }`,
                  transition: "all 0.3s ease",
                  position: "relative",
                  overflow: "hidden",
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(0,0,0,0.15)";
                  e.currentTarget.style.border = `3px solid ${
                    activeTab === "problems" ? "#f5be23" : "#3fa4ca"
                  }`;
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.1)";
                  e.currentTarget.style.border = `3px solid ${
                    activeTab === "problems"
                      ? "rgba(245, 190, 35, 0.2)"
                      : "rgba(63, 164, 202, 0.2)"
                  }`;
                }}
              >
                {/* Background Pattern */}
                <div
                  style={{
                    position: "absolute",
                    top: "-50px",
                    right: "-50px",
                    width: "100px",
                    height: "100px",
                    background: `linear-gradient(45deg, ${
                      activeTab === "problems"
                        ? "rgba(245, 190, 35, 0.1)"
                        : "rgba(63, 164, 202, 0.1)"
                    }, transparent)`,
                    borderRadius: "50%",
                    transition: "all 0.3s ease",
                  }}
                />

                {/* Icon */}
                <div
                  style={{
                    fontSize: "60px",
                    marginBottom: "25px",
                    filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.1))",
                  }}
                >
                  {item.icon}
                </div>

                {/* Title */}
                <h3
                  style={{
                    fontSize: "22px",
                    fontWeight: "700",
                    color: "#333",
                    margin: "0 0 15px 0",
                    fontFamily: '"Poppins", sans-serif',
                  }}
                >
                  {item.title}
                </h3>

                {/* Description */}
                <p
                  style={{
                    fontSize: "16px",
                    color: "#666",
                    lineHeight: "1.6",
                    margin: "0",
                    fontFamily: '"Poppins", sans-serif',
                  }}
                >
                  {item.description}
                </p>

                {/* Bottom accent line */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    height: "4px",
                    background: `linear-gradient(45deg, ${
                      activeTab === "problems" ? "#f5be23" : "#3fa4ca"
                    }, ${activeTab === "problems" ? "#ff8c00" : "#2c7da0"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </div>
            ))}
          </div>

          {/* Bottom CTA Section */}
          <div
            style={{
              textAlign: "center",
              marginTop: "60px",
              padding: "40px",
              background: `linear-gradient(135deg, ${
                activeTab === "problems"
                  ? "rgba(245, 190, 35, 0.1)"
                  : "rgba(63, 164, 202, 0.1)"
              }, transparent)`,
              borderRadius: "20px",
              border: `2px solid ${
                activeTab === "problems"
                  ? "rgba(245, 190, 35, 0.2)"
                  : "rgba(63, 164, 202, 0.2)"
              }`,
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: "#333",
                margin: "0 0 20px 0",
                fontFamily: '"Poppins", sans-serif',
              }}
            >
              {activeTab === "problems"
                ? "Ready to Overcome These Challenges?"
                : "Experience Our Solutions in Action"}
            </h3>
            <p
              style={{
                fontSize: "16px",
                color: "#666",
                margin: "0 0 30px 0",
                maxWidth: "600px",
                marginLeft: "auto",
                marginRight: "auto",
                lineHeight: "1.6",
              }}
            >
              {activeTab === "problems"
                ? "Let us help you transform construction challenges into successful project outcomes."
                : "Discover how our proven methodologies deliver exceptional results for every project."}
            </p>
            <button
              style={{
                padding: "15px 40px",
                background: `linear-gradient(45deg, ${
                  activeTab === "problems" ? "#f5be23" : "#3fa4ca"
                }, ${activeTab === "problems" ? "#ff8c00" : "#2c7da0"})`,
                color: "#fff",
                border: "none",
                borderRadius: "30px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
              }}
              onMouseEnter={e => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 8px 25px rgba(0,0,0,0.3)";
              }}
              onMouseLeave={e => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 6px 20px rgba(0,0,0,0.2)";
              }}
            >
              Get Started Today
            </button>
          </div>
        </div>

        {/* CSS for responsive design */}
        <style jsx>{`
          .desktop-toggle {
            margin: 0 auto;
          }
          
          .mobile-buttons {
            display: none;
          }
          
          .toggle-button {
            white-space: nowrap;
            min-height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          @media (max-width: 1200px) {
            .container {
              padding: 0 20px;
            }
            
            .desktop-toggle {
              min-width: 360px !important;
              max-width: 450px !important;
            }
          }
          
          @media (max-width: 992px) {
            .section-head {
              margin-bottom: 40px !important;
            }
            
            .desktop-toggle {
              min-width: 320px !important;
              max-width: 400px !important;
            }
            
            .toggle-button {
              font-size: 13px !important;
              padding: 12px 20px !important;
            }
          }
          
          /* Switch to separate buttons on mobile */
          @media (max-width: 768px) {
            .section-head div {
              flex-direction: column;
              align-items: center;
              padding: 0 15px;
            }
            
            .desktop-toggle {
              display: none !important;
            }
            
            .mobile-buttons {
              display: flex !important;
              flex-direction: column;
              gap: 12px;
              width: 100%;
              max-width: 400px;
              margin: 0 auto;
            }
            
            .mobile-buttons button {
              width: 100%;
              min-width: auto !important;
              margin: 0;
            }
          }
          
          @media (max-width: 480px) {
            .section-head div {
              padding: 0 20px;
            }
            
            .mobile-buttons {
              max-width: 350px;
              gap: 10px;
            }
            
            .mobile-buttons button {
              padding: 10px 20px !important;
              font-size: 12px !important;
            }
            
            .bottom-cta {
              padding: 30px 20px !important;
              margin-top: 40px !important;
            }
          }
          
          @media (max-width: 360px) {
            .mobile-buttons {
              max-width: 300px;
            }
            
            .mobile-buttons button {
              padding: 8px 16px !important;
              font-size: 11px !important;
            }
          }
          
          /* Grid responsive breakpoints */
          @media (max-width: 1200px) {
            div[style*="grid-template-columns"] {
              grid-template-columns: repeat(3, 1fr) !important;
            }
          }
          
          @media (max-width: 992px) {
            div[style*="grid-template-columns"] {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 25px !important;
            }
          }
          
          @media (max-width: 768px) {
            div[style*="grid-template-columns"] {
              grid-template-columns: 1fr !important;
              gap: 20px !important;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default ProblemSolution;
